import React, { useEffect, useMemo } from 'react'
import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material'
import { getDesignTokens } from '@src/theme'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { Provider } from 'react-redux'
import { store } from '@src/store'
import { BrowserRouter } from 'react-router'
import AuthProvider from '@src/providers/AuthProvider'
import AppRoutes from '@src/AppRoutes'
import moment from 'moment'
import 'moment/locale/ru'
import 'moment-timezone'
import FormDialogProvider from '@components/dialogs/FormDialog/FormDialogPrvider'
import { useAppDispatch, useIsTablet } from '@src/hooks'
import { setSidebarWidth } from '@store/app'
import { DEFAULT_SIDEBAR_WIDTH } from '@src/config'

moment.locale('ru')
moment.HTML5_FMT.DATE = 'DD.MM.YYYY'
moment.HTML5_FMT.DATETIME_LOCAL = 'DD.MM.YYYY HH:mm'
// moment.tz.setDefault('Europe/Moscow')

type AppProps = {
  children: React.ReactElement;
}
const App = ({ children }: AppProps) => {
  const isTablet = useIsTablet()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setSidebarWidth(isTablet ? 0 : DEFAULT_SIDEBAR_WIDTH))
  }, [ isTablet ])

  return children
}


// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)', {
    noSsr: true
  })

  const theme = useMemo(() => {
    // return createTheme(getDesignTokens(prefersDarkMode ? 'dark' : 'light'))
    return createTheme(getDesignTokens('light'))
  }, [ prefersDarkMode ])

  return (
    <React.StrictMode>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <AuthProvider>
                <FormDialogProvider>
                  <App>
                    <AppRoutes />
                  </App>
                </FormDialogProvider>
              </AuthProvider>
            </BrowserRouter>
          </ThemeProvider>
        </LocalizationProvider>
      </Provider>
    </React.StrictMode>
  )
}
